import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../utils/LoadingSpinner';

const StatsDailyChart = ({ data, loading }) => {
	if (loading) {
		return <LoadingSpinner loadingMsg='Loading daily stats' />;
	}

	if (!data || data.length === 0) {
		return <p className='text-center text-muted mt-3'>No daily data available</p>;
	}

	const chartData = data.map(item => ({
		date: item.date || '',
		total: item.total || 0,
		errors: item.errors || 0
	}));

	return (
		<ResponsiveContainer width='100%' height={350}>
			<AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
				<CartesianGrid strokeDasharray='3 3' />
				<XAxis dataKey='date' fontSize={12} />
				<YAxis />
				<Tooltip />
				<Legend />
				<Area type='monotone' dataKey='total' stroke='#0d6efd' fill='#0d6efd' fillOpacity={0.3} name='Total Jobs' />
				<Area type='monotone' dataKey='errors' stroke='#dc3545' fill='#dc3545' fillOpacity={0.3} name='Errors' />
			</AreaChart>
		</ResponsiveContainer>
	);
}

StatsDailyChart.propTypes = {
	data: PropTypes.array,
	loading: PropTypes.bool
}

export default StatsDailyChart;
